// Typelizer digest 8f8be1a6c1d423ff3cd5a7a848f548d3
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /learners/students/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/students/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /learners/students/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/students/:id', params, options),
    method: 'get',
  }),

  /** PATCH /learners/students/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/learners/students/:id', params, options),
    method: 'patch',
  }),
}
